type Taction<T> = {
    save(data: T): void;
    clear(): void;
    data: T;
}


export interface IBanner {
    banner: { mobile: string, pc: string }
    name: string
    p_gid: number
    redirect_url: string
}

export interface IinitData {
    agreement: string[]
    banner: IBanner[]
    float: Record<string, unknown>[]
    popup: string[]
}

export interface IGameInfo {
    banner?: {
        mobile_img?: string
        pc_img?: string
    }
}

import { reactive, ref } from 'vue';
import { defineStore } from 'pinia';
import { getOS, getIdfa } from '@/common/ts/utils';
import { prefix } from '@/config/index';



const PREFIX = prefix || '';
const SDK_VERSION = '1.0.0';

const sdkVersion = ref(SDK_VERSION);

interface IUrlParams {
    pid: string
    gid: string
    mid: string
    p_mid: string
    os?: string
    os_ver?: string
}

function parseUrlParams(): IUrlParams {
    const url = window.location.href;
    const params: IUrlParams = {
        pid: '',
        gid: '',
        mid: '10000',
        p_mid: '1'
    };

    if (!url.includes('?')) return params;

    const queryString = url.split('?')[1];
    const paramPairs = queryString.split('&');
    const checkKeys = [`${PREFIX}Pid`, `${PREFIX}Gid`, `${PREFIX}Mid`, `${PREFIX}PMid`];

    for (const pair of paramPairs) {
        const [encodedKey, encodedValue] = pair.split('=');
        if (!encodedValue) continue;

        let key = decodeURIComponent(encodedKey);
        const value = decodeURIComponent(encodedValue);

        if (checkKeys.includes(key)) {
            key = key.toLowerCase().split(PREFIX)[1];
        }

        if (key === 'pmid') {
            key = 'p_mid';
        }

        if (key === 'gid') {
            params[key] = value.substring(0, 6);
        } else if (key in params && !params[key as keyof IUrlParams]) {
            params[key as keyof IUrlParams] = value;
        }
    }

    return params;
}

export const useComDataStore = defineStore(
    'comDataStore',
    () => {
        const urlParams = parseUrlParams();

        const defaultComReqData = {
            pid: 1003,
            gid: 100005,
            mid: urlParams.mid,
            p_mid: urlParams.p_mid,
            device_id: getIdfa(),
            os: urlParams.os || getOS(),
            os_ver: urlParams.os_ver || getOS(),
            sdk_ver: sdkVersion.value,
        };

        const comReqData = reactive({ ...defaultComReqData });

        const comReqDataAction = reactive({
            save(data: Partial<typeof defaultComReqData>) {
                Object.assign(comReqData, data);
            },
            clear() {
                Object.assign(comReqData, defaultComReqData);
            },
            data: comReqData,
        });


        const defaultInitData: IinitData = {
            agreement: [],
            banner: [],
            float: [],
            popup: [],
        };

        const initData = reactive<IinitData>({ ...defaultInitData });
        const initDataAction = reactive<Taction<IinitData>>({
            save(data: Partial<IinitData>) {
                Object.assign(initData, data);
            },
            clear() {
                Object.assign(initData, defaultInitData);
            },
            data: initData,
        });




        const lastInPGID = ref('')
        const lastInPGIDAction = reactive({
            save(id: string) {
                lastInPGID.value = id
            }
        })




        return {
            comReqData,
            comReqDataAction,

            initData,
            initDataAction,

            lastInPGID,
            lastInPGIDAction
        };
    },
    {
        persist: {
            enabled: true,
            strategies: [
                { key: 'comDataStore', storage: localStorage, paths: ['comReqData', 'lastInPGID'] },
            ],
        }
    }
);